/**
 * @module gisw/env
 * @description
 * Helper methods for user authentication.
 */
define(['dojo/Deferred', 'dojo/request'], function (Deferred, request) {
  'use strict';

  return {
    /**
     * @param {object} options
     * @param {string} [options.loginUrl]
     * @param {string} [options.logoutUrl]
     * @param {string} [options.entityName]
     * @param {boolean} [options.loggedIn]
     * @param {boolean} [options.siteHasLogin]
     * @param {boolean} [options.siteLoginRequired]
     * @param {boolean} [options.permissionRequiredForTab]
     */
    init (options) {
      this.loginUrl = options.loginUrl || 'Login/loginGetEntityInfo';
      this.logoutUrl = options.logoutUrl || 'Login/logout';
      this.entityName = options.entityName || '';
      this.loggedIn = options.loggedIn || false;
      this.siteHasLogin = options.siteHasLogin || false;
      this.siteLoginRequired = options.siteLoginRequired || false;
      this.permissionRequiredForTab = options.permissionRequiredForTab || false;

      this.loginInfo = null;
    },

    /**
     * @param {string} username
     * @param {string} password
     * @param {boolean} ignoreURLTab
     * @returns {Promise<any>}
     */
    authenticate (username, password, ignoreURLTab) {
      const that = this;
      const deferred = new Deferred();
      const postData = JSON.stringify({
        e: this.entityName,
        username,
        password,
        ignoreURLTab
      });

      this.sendRequest(this.loginUrl, postData).then(
        function (data) {
          if (_loginSuccess(data)) {
            that.loggedIn = data.CredencialMsg !== 'public';
            that.loginInfo = data;
            deferred.resolve(data);
          } else {
            deferred.reject('Invalid credentials.');
          }
        },
        function (err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    },

    /**
     * @param {string} url
     * @param {string} data JSON string data
     * @returns {Promise<any>}
     */
    sendRequest (url, data) {
      return request(url, {
        method: 'POST',
        handleAs: 'json',
        data,
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Accept: 'application/json'
        }
      });
    },

    /**
     * @returns {Promise<string>} Logout result
     */
    logout () {
      const that = this;
      const deferred = new Deferred();

      this.sendRequest(this.logoutUrl, null).then(
        function (data) {
          if (_logoutSuccess(data)) {
            that.loggedIn = false;
            that.loginInfo = null;
            deferred.resolve('Success.');
          } else {
            deferred.reject('Fail.');
          }
        },
        function (err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    }
  };

  function _loginSuccess (r) {
    return !!r && (r.CredencialMsg === 'valid' || r.CredencialMsg === 'public');
  }

  function _logoutSuccess (r) {
    return r.CredencialMsg === 'Logout';
  }
});
